
import { defineComponent, ref, onMounted, watch } from "vue";
import { usePlugin } from "@/plugins";
import { GetInstructorRequest, Instructor } from "@/types";

export default defineComponent({
  name: "InputInstructor",
  props: {
    modelValue: {
      type: String,
    },
  },
  setup(props, { emit }) {
    const { axios, error, information } = usePlugin();
    const instructors = ref([] as Instructor[]);
    const selectedInstructor = ref("");

    const loadInstructors = async () => {
      try {
        const result = await axios.post<Instructor[]>(
          "api/v1/services/instructor/get",
          { searchString: "" } as GetInstructorRequest
        );
        instructors.value = result.data;
        if (result.data.length === 0) information("ไม่พบข้อมูล");
      } catch (e) {
        error("ไม่สามารถติดต่อ server กรุณาลองใหม่ภายหลัง");
      }
    };

    watch(
      () => props.modelValue,
      () => {
        selectedInstructor.value = props.modelValue ?? "";
      }
    );

    onMounted(async () => {
      await loadInstructors();
      if (props.modelValue) {
        selectedInstructor.value = props.modelValue;
      }
    });

    const onSelectInstructor = (value: any) => {
      emit("update:modelValue", value.value);
    };

    return {
      instructors,

      selectedInstructor,
      onSelectInstructor,
    };
  },
});
